module.exports = __webpack_public_path__ + "img/newText.88eb0437.png";